import StorageHandler from './StorageHandler.js';
import FetchData from './FetchData.js';
import { useLanguageStore } from '@/store/languageStore.js';

class Translator {
  async LoadTranslates() {
    // Check if translations are already cached in localStorage
    let Translations = StorageHandler.LoadSessionStorage('Translations', 60); // Cache valid for 60 minutes
    if (Translations) {
      return Translations;
    }
    const route = 'Translations';
    const method = 'POST';
    const query = true;
    const languageStore = useLanguageStore();
    const selectedLanguage = languageStore.selectedLanguage?.alternative || languageStore.selectedLanguage?.code || 'cs';
    const config = {
      select: [
        "link",
        selectedLanguage
      ]
    };

    try {
      const response = await FetchData(config, route, method, query);
      if (response && Array.isArray(response)) {
        const translations = response.reduce((acc, item) => {
          acc[item.link] = item[selectedLanguage];
          return acc;
        }, {});
        // Store translations in localStorage
        StorageHandler.InsertSessionStorage('Translations', translations);
        return translations;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Error fetching translations:', error);
      
      return null;
    }
  }

  async GetTranslation(key) {
    const route = 'Translations/' + key;
    const method = 'GET';
    const query = false;
    const config = {};
    try {
      const response = await FetchData(config, route, method, query);
      if (response && response.link) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error('Error fetching translation:', error);
      return false;
    }
  }

  async AddTranslation(key){
    let exists = await this.GetTranslation(key);
    if(exists) {
      StorageHandler.RemoveSessionStorage('Translations'); // Clear cache if translation exists
      this.LoadTranslates(); // Reload translations
      return null; // Translation already exists
    }
    const route = 'Translations';
    const method = 'POST';
    const query = false;
    const config = {
      link: key
    };
    try {
      await FetchData(config, route, method, query);
      StorageHandler.RemoveSessionStorage('Translations'); // Clear cache if translation exists
      this.LoadTranslates(); // Reload translations after adding a new one
    } catch (error) {
      console.error('Error fetching translations:', error);
      this.$toast.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to add translation.',
        life: 3000,
      })
      return null;
    }
  }

  async changeTranslation(link, value, lang){
    const route = "Translations" + '/' + link;
    const method = 'PUT';
    const query = false;
    const config = {
      [lang]: value
    };
    try {
      await FetchData(config, route, method, query);
      this.LoadTranslates(); // Reload translations after changing one
    } catch (error) {
      console.error('Error fetching translations:', error);
      this.$toast.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to change translation.',
        life: 3000,
      })
      return null;
    }
  }

  async ReloadTranslations() {
    // Clear the session storage to force a reload of translations
    StorageHandler.RemoveSessionStorage('Translations');
    // Reload translations from the server
    return await this.LoadTranslates();
  }
}

export default Translator;